export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "https://qa-app.summerbayresort.com.my",
    backendUrl: "http://localhost:3100",
    agentBackendUrl: "http://localhost:4041",
    jsReportUrl: "http://localhost:5488",
    s3Url: "https://sbay-s3b-test.s3.ap-southeast-1.amazonaws.com",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://qa-app.summerbayresort.com.my";
    exportResult.backendUrl = "https://qa-api.summerbayresort.com.my/admin";
    exportResult.agentBackendUrl =
      "https://qa-api.summerbayresort.com.my/business";
    exportResult.userPortalBackendUrl =
      "https://qa-api.summerbayresort.com.my/app";
    exportResult.jsReportUrl = "https://qa-report.summerbayresort.com.my";
    exportResult.s3Url = "https://sbay-s3b-test.s3.ap-southeast-1.amazonaws.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.agentBackendUrl = "https://business-api.travoxis.com";
    exportResult.userPortalBackendUrl = "https://app-api.travoxis.com";
    exportResult.jsReportUrl = "https://report-test.summerbayresort.com.my";
    exportResult.s3Url = "https://sbay-s3b-test.s3.ap-southeast-1.amazonaws.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.summerbayresort.com.my";
    exportResult.backendUrl = "https://api.summerbayresort.com.my/admin";
    exportResult.agentBackendUrl =
      "https://api.summerbayresort.com.my/business";
    exportResult.userPortalBackendUrl =
      "https://api.summerbayresort.com.my/app";
    exportResult.jsReportUrl = "https://report.summerbayresort.com.my";
    exportResult.s3Url = "https://sbay-s3b-prod.s3.ap-southeast-1.amazonaws.com";
  }
  return exportResult;
};
